module.exports = __webpack_public_path__ + "img/illu-log.d64d15c8.svg";